import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import { Header } from "./components/Header";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Journal from "./pages/Journal";
import Profile from "./pages/Profile";
import Marketing from "./pages/Marketing";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "./components/auth/AuthProvider";
import { CheckoutSuccess } from "./components/checkout/CheckoutSuccess";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  }
});

const App = () => {
  const [user, setUser] = useState(null);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        {/* Commenting out Sonner to prevent duplicate toast providers */}
        {/* <Sonner /> */}
        <BrowserRouter>
          <AuthProvider onUserChange={setUser}>
            <div className="min-h-screen flex flex-col">
              <Header user={user} />
              <main className="flex-1">
                <Routes>
                  <Route 
                    path="/" 
                    element={
                      <>
                        <CheckoutSuccess />
                        {user ? <Index /> : <Marketing />}
                      </>
                    } 
                  />
                  <Route 
                    path="/app" 
                    element={
                      user ? (
                        <Index />
                      ) : (
                        <Navigate to="/auth" replace />
                      )
                    } 
                  />
                  <Route 
                    path="/auth" 
                    element={!user ? <Auth /> : <Navigate to="/app" replace />} 
                  />
                  <Route 
                    path="/journal" 
                    element={user ? <Journal /> : <Navigate to="/auth" replace />} 
                  />
                  <Route 
                    path="/profile" 
                    element={user ? <Profile /> : <Navigate to="/auth" replace />} 
                  />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
            </div>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
